// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rv-2";
export var chatLink = "_rv-0";
export var chatText = "_rv-1";